<template>
  <div class="container">
    <div class="col-md-6 mx-auto">
      <div class="card border-primary mt-5">
        <div class="card-header bg-success">
          <h5 class="card-title text-white text-center">Login page</h5>
        </div>
        <div class="card-body">
          <form @submit.prevent="OnLogin">
            <BaseInput
              placeholder="User Name"
              @blur="$v.LoginUser.UserName.$touch()"
              :error="$v.LoginUser.UserName.$error"
              v-model="LoginUser.UserName"
              type="text"
            />
            <BaseInput
              placeholder="Password"
              @blur="$v.LoginUser.Password.$touch()"
              :error="$v.LoginUser.Password.$error"
              v-model="LoginUser.Password"
              type="password"
            />

            <BaseButton
              :className="{
                'w-50': true,
                'float-right': true,
                'btn-success': true
              }"
              :disabled="clicked"
              type="submit"
            >
              <span
                class="spinner-border-sm"
                :class="{ 'spinner-border': clicked }"
                role="status"
                aria-hidden="true"
              ></span>
              {{ clicked ? "Loading..." : "Login" }}
            </BaseButton>
            <p class="text-danger text-center">{{ msg }}</p>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { required } from "vuelidate/lib/validators";
export default {
  validations: {
    LoginUser: {
      UserName: { required },
      Password: { required }
    }
  },
  data() {
    return {
      clicked: false,
      msg: "",
      LoginUser: {
        UserName: "",
        Password: ""
      }
    };
  },
  methods: {
    OnLogin() {
      if (!this.$v.LoginUser.$invalid) {
        this.clicked = true;
        this.msg = "";
        this.$store
          .dispatch("login", this.LoginUser)
          .then(() => {
            this.clicked = false;
          })
          .catch(err => {
            // console.log(err.response);
            this.clicked = false;
            this.msg = err.response.data;
            // if (err.response.status === 404) this.msg = err.response.data;
            // else this.msg = "internal Error Try again";
          });
      } else this.msg = "Enter User name and password";
    }
  }
};
</script>
